import { BehaviorSubject } from 'rxjs';

import { useObservableState } from 'common/components/core/hooks/useObservableState';
import { WebSocketConnectionState } from 'common/constants/webSocketConnectionState';

export const webSocketStateSubject = new BehaviorSubject<WebSocketConnectionState>(WebSocketConnectionState.CLOSED);

export function useWebSocketConnectionState() {
  return useObservableState(webSocketStateSubject);
}
